import { render, staticRenderFns } from "./CampaignPublicViewPayment.vue?vue&type=template&id=63bea406&scoped=true"
import script from "./CampaignPublicViewPayment.vue?vue&type=script&lang=js"
export * from "./CampaignPublicViewPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bea406",
  null
  
)

export default component.exports